// extracted by mini-css-extract-plugin
module.exports = {"Container":"SettingsForm_Container__3j4Pp","Form":"SettingsForm_Form__3KwE5","InputForms":"SettingsForm_InputForms__2AUsi","Inputs":"SettingsForm_Inputs__3oFbc"};